import { render, staticRenderFns } from "./clashofwars.vue?vue&type=template&id=295e8f7a&scoped=true"
import script from "./clashofwars.vue?vue&type=script&lang=js"
export * from "./clashofwars.vue?vue&type=script&lang=js"
import style0 from "./clashofwars.vue?vue&type=style&index=0&id=295e8f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e8f7a",
  null
  
)

export default component.exports